module.exports = __webpack_public_path__ + "img/pindao.4d5d4d24.png";